import { render, staticRenderFns } from "./DesignContent.vue?vue&type=template&id=651797c2&scoped=true&"
import script from "./DesignContent.vue?vue&type=script&lang=js&"
export * from "./DesignContent.vue?vue&type=script&lang=js&"
import style0 from "./DesignContent.vue?vue&type=style&index=0&id=651797c2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651797c2",
  null
  
)

export default component.exports